import {
	CreateLocalTrackOptions,
	LocalAudioTrack,
	LocalVideoTrack,
} from 'twilio-video';
const operations = new WeakMap<object, Promise<void>>();
export function restartDevice(
	track: LocalAudioTrack | LocalVideoTrack,
	options: CreateLocalTrackOptions,
	active: () => boolean,
) {
	if (operations.has(track)) return operations.get(track)!;
	const enabled = track.isEnabled;
	const operation = (async () => {
		try {
			await track.restart(options);
		} catch (error) {
			if (!active()) {
				track.stop();
				return;
			}
			if (
				['NotAllowedError', 'SecurityError'].includes(
					(error as Error).name,
				)
			)
				throw error;
			await track.restart({});
		}
		if (!active()) {
			track.stop();
			return;
		}
		if (!enabled) track.disable();
	})();
	const result = operation.finally(() => operations.delete(track));
	operations.set(track, result);
	return result;
}

// Serialize routing on each element so a slow old selection cannot win a race.
const routing = new WeakMap<HTMLMediaElement, Promise<void>>();
export function routeAudio(element: HTMLMediaElement, sinkId: string) {
	const previous = routing.get(element) || Promise.resolve();
	const next = previous
		.catch(() => {})
		.then(() => element.setSinkId?.(sinkId));
	routing.set(element, next);
	void next
		.finally(() => {
			if (routing.get(element) === next) routing.delete(element);
		})
		.catch(() => {});
	return next;
}
